import tinycolor from 'tinycolor2';

/**
 * Hardcoded palette of 10 colors for diet categories
 */
const DIET_COLORS = [
  '#CAD5E2',
  '#7FD89A',
  '#C4B4FF',
  '#B8E6FE',
  '#FEE685',
  '#98D8C8',
  '#4ECDC4',
  '#F8B88B',
  '#FF6B6B',
  '#45B7D1',
];

/**
 * Assign colors to diets based on their index
 * Colors cycle through the palette if there are more than 10 diets
 * @param {Array} diets - Array of diet objects
 * @returns {Array} Diets with color assigned
 */
export function assignDietColors(diets) {
  if (!diets || diets.length === 0) return [];

  return diets.map((diet, index) => {
    const color = DIET_COLORS[index % DIET_COLORS.length];

    return {
      ...diet,
      color,
      textColor: tinycolor(color).darken(50).toString(),
    };
  });
}

/**
 * Convert a hex color to a lighter shade by mixing with white
 * @param {string} color - Hex color code (e.g., '#FF6B6B')
 * @returns {string} RGB color string of the lighter shade
 */
export function getLighterColor(color) {
  // Convert hex to RGB
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Mix with white (80% white, 20% original color for a lighter shade)
  const newR = Math.round(r + (255 - r) * 0.8);
  const newG = Math.round(g + (255 - g) * 0.8);
  const newB = Math.round(b + (255 - b) * 0.8);

  return `rgb(${newR}, ${newG}, ${newB})`;
}
